import { Builder } from '@builder.io/react';

// UI
import 'react-scale/components/elements/header/header.builder';
import 'react-scale/components/elements/footer/footer.builder';
import 'react-scale/components/elements/navigation/navigation.builder';
import 'react-scale/components/elements/section/section.builder';
import 'react-scale/components/elements/section-title/section-title.builder';
import 'react-scale/components/elements/blurb/blurb.builder';
import 'react-scale/components/elements/features/features.builder';
import 'react-scale/components/elements/features-roi/features-roi.builder';
import 'react-scale/components/elements/new-features/features.builder';
import 'react-scale/components/elements/slide-gallery/slide-gallery.buillder';
import 'react-scale/components/elements/video/video.builder';
import 'react-scale/components/elements/video-modal/video-modal.builder';
import 'react-scale/components/elements/tab-cta/tab-cta.builder';
import 'react-scale/components/elements/quote-ui/quote-ui.builder';
import 'react-scale/components/elements/quote/quote.builder';
import 'react-scale/components/elements/quality-assurance/quality-assurance.builder';
import 'react-scale/components/elements/logo-marquee/logo-marquee.builder';
import 'react-scale/components/elements/logo-grid/logo-grid.builder';
import 'react-scale/components/elements/logo-farm/logo-farm.builder';
import 'react-scale/components/elements/cta/cta.builder';
import 'react-scale/components/elements/card-cta/card-cta.builder';
import 'react-scale/components/elements/data-slider/data-slider.builder';
import 'react-scale/components/elements/box/box.builder';
import 'react-scale/components/elements/box-rlhf/box-rlhf.builder';
import 'react-scale/components/elements/box-data-curation/box-data-curation.builder';
import 'react-scale/components/elements/box-data-labeling/box-data-labeling.builder';
import 'react-scale/components/elements/data-box/data-box.builder';
import 'react-scale/components/elements/text/text.builder';
import 'react-scale/components/elements/flow-grid/flow-grid';
import 'react-scale/components/elements/video-gallery/video-gallery.builder';
import 'react-scale/components/elements/table/table.builder';
import 'react-scale/components/elements/iframe/iframe.builder.ts';
import 'react-scale/components/elements/transformx/header.builder';

// Pages/Customs
import 'react-scale/components/pages/enterprise-ai/iceberg/iceberg.builder';
import 'react-scale/components/pages/document-use-cases/after-scale/after-scale.builder';
import 'react-scale/components/pages/labeling/training/training.builder';
import 'react-scale/components/pages/open-datasets/get-started/get-started.builder';
import 'react-scale/components/pages/open-datasets/ukraine/damage-map/damage-map.builder';
import 'react-scale/components/pages/open-datasets/stats/stats.builder';
import 'react-scale/components/pages/retail/hero/retail-hero.builder';
import 'react-scale/components/pages/document/hero/document-hero.builder';
import 'react-scale/components/pages/document/spin-banner/document-spin-banner.builder';
import 'react-scale/components/pages/document/industries/document-industries.builder';
import 'react-scale/components/pages/launch/how-it-works/how-it-works.builder';
import 'react-scale/components/pages/catalog/how-it-works/how-it-works.builder';
import 'react-scale/components/pages/sales/step-form/form-content/form-content.builder';

// Sections
import 'react-scale/components/sections/enterprise-ready/enterprise-ready.builder';
import 'react-scale/components/sections/languages/languages.builder';
import 'react-scale/components/sections/cta/simple-centered/simple-centered.builder';
import 'react-scale/components/sections/hero/hero-default.builder';
import 'react-scale/components/sections/hero/hero-input/hero-input.builder';
import 'react-scale/components/sections/hero/hero-default-with-video.builder';
import 'react-scale/components/sections/hero/hero-slider/hero-slider.builder';
import 'react-scale/components/sections/hero/hero-default-with-slider.builder';
import 'react-scale/components/sections/hero/hero-teaser/hero-teaser.builder';
import 'react-scale/components/sections/hero/hero-default-with-image.builder';
import 'react-scale/components/sections/hero/hero-default-left.builder';
import 'react-scale/components/sections/hero/big-webgl/big-webgl.builder';
import 'react-scale/components/sections/hero/simple-centered/simple-centered-hero.builder';
import 'react-scale/components/sections/hero/hero-centered.builder';
import 'react-scale/components/sections/hero/centralized-hero/centralized-hero.builder';
import 'react-scale/components/sections/hero/simple-left.builder';
import 'react-scale/components/sections/banner/banner.builder';
import 'react-scale/components/sections/comparison/comparison.builder';
import 'react-scale/components/sections/data-inputs-modular/data-inputs-modular.builder';
import 'react-scale/components/sections/video-showcase/video-showcase.builder';
import 'react-scale/components/sections/example/example.builder';
import 'react-scale/components/sections/image-block/image-block.builder';
import 'react-scale/components/sections/feature-grid/feature-grid.builder';
import 'react-scale/components/sections/events/events.builder';
import 'react-scale/components/sections/pricing/pricing.builder';
import 'react-scale/components/sections/comparison-table/comparison-table.builder';
import 'react-scale/components/sections/overview/overview.builder';
import 'react-scale/components/sections/stats-grid/stats-grid.builder';
import 'react-scale/components/sections/faq/faq.builder';
import 'react-scale/components/sections/quality-assurance/quality-assurance.builder';
import 'react-scale/components/solutions/Hero/solutions-hero.builder';
import 'react-scale/components/solutions/Features/solutions-features.builder';
import 'react-scale/components/solutions/UseCases/solutions-use-cases.builder';
import 'react-scale/components/solutions/Why/solutions-why.builder';

// Products
import 'react-scale/components/products/ImageBlock/products-image-block.builder';

// Data
import 'react-scale/components/data/logo-grid/logo-grid.builder';

// Nucleus components
import 'react-scale/components/sections/hero/hero-product/hero-product.builder';
import 'react-scale/components/pages/nucleus/gallery/gallery.builder';

// Rapid components
import { GalleryCountdown, Pricing, DataInputs } from 'react-scale/components/pages/rapid';

// Rapid components

Builder.registerComponent(GalleryCountdown, {
  name: 'GalleryCountdown'
});

Builder.registerComponent(Pricing, {
  name: 'Pricing'
});

Builder.registerComponent(DataInputs, {
  name: 'DataInputs',
  inputs: [
    {
      name: 'dataLanguages',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'sensorFusion',
      type: 'boolean',
      defaultValue: true
    }
  ]
});
